import { render, staticRenderFns } from "./ModalPatientTasksList.vue?vue&type=template&id=22cc20e4&scoped=true&lang=pug"
import script from "./ModalPatientTasksList.vue?vue&type=script&lang=js"
export * from "./ModalPatientTasksList.vue?vue&type=script&lang=js"
import style0 from "./ModalPatientTasksList.vue?vue&type=style&index=0&id=22cc20e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc20e4",
  null
  
)

export default component.exports